module.exports = __webpack_public_path__ + "img/analytics.55ef5294.svg";